<template>
  <div class="flex onboarding-block-wrapper">
    <img
      v-if="displayAvatar"
      class="avatar"
      src="https://logo.wondercv.com/banners/rFXnEYEDDxKYuKX.png"
      alt=""
    />
    <div class="onboarding-block-container progress-container">
      <div v-if="fileImage && fileImage.includes('iconfont')" class="iconfont-content">
        <i :class="fileImage"></i>
      </div>
      <img v-else-if="fileImage" class="file-image" :src="fileImage" alt="" />
      <div v-if="fileName" class="file-name">{{ fileName }}</div>
      <ProgressBar :percentage="percentage" />
    </div>
  </div>
</template>
<script>
import ProgressBar from './ProgressBar.vue';
export default {
  name: 'Progress',
  components: {
    ProgressBar,
  },
  props: {
    fileImage: String,
    fileName: String,
    token: String,
    percentage: {
      type: Number,
      default: 0,
    },
    displayAvatar: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/index.scss';
.onboarding-block-wrapper {
  .progress-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 620px;
    height: 254px;
    .iconfont-content {
      .iconfont {
        font-size: 56px;
        background: linear-gradient(90deg, #FFBA52 0%, #F5563C 100%);
        color: #ffffff; // 兜底颜色，防止文字裁剪不生效
        background-clip: text;
        -webkit-background-clip: text; // 背景被裁减为文字的前景色
        -webkit-text-fill-color: transparent; // 文字填充为透明，优先级比color高。
      }
    }
    .file-image {
      width: 56px;
      height: 56px;
      margin-bottom: 20px;
    }
    .file-name {
      font-weight: 500;
      color: #fff;
      margin-bottom: 30px;
    }
  }
}
</style>
